// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__3EW7g","main":"Footer_main___7wug","names":"Footer_names__2JIbB","commentMessage":"Footer_commentMessage__2sadT","email":"Footer_email__XqiBQ"};